export enum Kind {
  Null = 'null',
  String = 'string',
  Undefined = 'undefined',
  Array = 'array',
  ArrayLike = 'arraylike',
  Class = 'class',
  Function = 'function',
  Symbol = 'symbol',
  Number = 'number',
  Date = 'date',
  Boolean = 'boolean',
  RegExp = 'regexp',
  Buffer = 'buffer',
  NaN = 'nan',
  Set = 'set',
  Map = 'map',
  ArrayBuffer = 'arraybuffer',
  Error = 'error',
  Promise = 'promise',
  WeakMap = 'weakmap',
  WeakSet = 'weakset',
  Int8Array = 'int8array',
  Uint8Array = 'uint8array',
  Uint8ClampedArray = 'uint8clampedarray',
  Object = 'object',
  Element = 'element',
}

export default Kind;
